var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddEnable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "21-View-order-select-any-bullet-point",
    transform: "translate(-1064.000000, -838.000000)",
    fill: "#279CF7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ticket-information",
    transform: "translate(64.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1010.5,154 C1016.29899,154 1021,158.70101 1021,164.5 C1021,170.29899 1016.29899,175 1010.5,175 C1004.70101,175 1000,170.29899 1000,164.5 C1000.00434,158.70281 1004.70281,154.004343 1010.5,154 Z M1011.94375,158.055625 L1009.05625,158.055625 L1009.05625,163.05625 L1004.05562,163.05625 L1004.05562,165.94375 L1009.05625,165.94375 L1009.05625,170.944375 L1011.94375,170.944375 L1011.94375,165.94375 L1016.94438,165.94375 L1016.94438,163.05625 L1011.94375,163.05625 L1011.94375,158.055625 Z",
    id: "add"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEnable);
export default __webpack_public_path__ + "static/media/add-enable.977243ee5a7d207d4c3bfbd065f3f2ca.svg";
export { ForwardRef as ReactComponent };